const toCamel = (str: string): string => {
  return str.replace(/([_-][a-z0-9])/gi, ($1: string) => {
    return $1.toUpperCase().replace("-", "").replace("_", "");
  });
};

const isArray = function (
  input: Record<string, unknown> | Record<string, unknown>[] | unknown
): input is Record<string, unknown>[] {
  return Array.isArray(input);
};

const isObject = function (
  obj: Record<string, unknown> | Record<string, unknown>[] | unknown
): obj is Record<string, unknown> {
  return (
    obj === Object(obj) && !Array.isArray(obj) && typeof obj !== "function"
  );
};

export const camelize = function <T>(input: T): T {
  return (function recurse<
    K extends Record<string, unknown> | Record<string, unknown>[] | unknown
  >(input: K): K {
    if (isObject(input)) {
      return Object.keys(input).reduce((previousValue, currentValue) => {
        return Object.assign(previousValue, {
          [toCamel(currentValue)]: recurse(input[currentValue]),
        });
      }, {} as Extract<K, Record<string, unknown>>);
    } else if (isArray(input)) {
      return input.map((i) => recurse(i)) as K;
    }
    return input;
  })(input);
};

export const handleize = function (s: string) {
  let string = s.toLowerCase();

  const toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  toReplace.forEach((char) => string.replace(char, ""));

  string = string.replace(/\W+/g, "-");

  if (string.charAt(string.length - 1) === "-") {
    string = string.replace(/-+z/, "");
  }

  if (string.charAt(0) === "-") {
    string = string.replace(/A-+/, "");
  }

  return string;
};

export const normalize = (s: string) => {
  // Normalize common diacritics
  return s
    .toLowerCase()
    .replace(/è/g, "e")
    .replace(/é/g, "e")
    .replace(/ê/g, "e")
    .replace(/à/g, "a")
    .replace(/â/g, "a")
    .replace(/î/g, "i")
    .replace(/ï/g, "i")
    .replace(/ô/g, "o")
    .replace(/ù/g, "u")
    .replace(/û/g, "u")
    .replace(/ü/g, "u")
    .replace(/ç/g, "c");
};

export const transformToParamKey = (string: string) => {
  return string.toLowerCase().replaceAll(" ", "_");
};

export const interpolateTranslationString = (
  text: string,
  variableValues: string[]
) => {
  let replacementIndex = 0;
  return text.replace(/\${[^}]+}/g, () => {
    const replacement = variableValues[replacementIndex];
    replacementIndex++;
    return replacement !== undefined ? replacement : "";
  });
};

export const validateEmailAddress = function (input: string) {
  return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/gm.test(
    input
  );
};
